/**
 * Access API service for the signed-in caller's own access.
 */

import type { MyAccessResponse } from "@/generated/sdk"

import { sdk, sdkCall } from "./sdk"

export type { MyAccessResponse } from "@/generated/sdk"

export const accessApi = {
  /**
   * Fetch the caller's set audiences, set capabilities, and tenant capabilities.
   */
  getMyAccess: async (): Promise<MyAccessResponse> => {
    return sdkCall(sdk.getMyAccess())
  },
}
